import { AxiosInstance } from "./client";
import { TagsApis } from "./endpoints";

export const getTags = (params) => {
  return AxiosInstance()
    .get(TagsApis.LIST_TAGS, { params })
    .then((response) => response?.data?.data);
};
